<life-di-nav></life-di-nav>
<lifedi-breadcrumb></lifedi-breadcrumb>

<div *ngIf="quotationForm" class="container py-3">
    <div *ngIf="isEdit">
        <button
            *ngIf="quotationDetail.STATUS !== 'Done' && quotationDetail.STATUS !== 'Cancel' && quotationDetail.STATUS !== 'Partial'"
            class="btn btn-outline-danger" style="position: absolute; right: 3%;"
            (click)="cancel(quotationDetail.QUOTATION_NO, quotationDetail.QUOTATION_VERSION)">
            ยกเลิกใบเสนอราคา
        </button>
    </div>

    <h1 *ngIf="!isEdit" class="text-center lifedi-color mb-5">
        สร้างใบเสนอราคา
    </h1>
    <h1 *ngIf="isEdit" class="text-center lifedi-color mb-5">
        ใบเสนอราคา {{ id }}
    </h1>

    <div class="row d-flex justify-content-center">
        <div class="col-12 col-md-3">
            <div class="form-group row">
                <label for="courseType" class="text-right col-4 col-sm-3 col-md-3 col-form-label">
                    เวอร์ชัน<lifedi-require></lifedi-require>
                </label>
                <div class="col-8 col-sm-9 col-md-9">
                    <select *ngIf="isEdit" class="custom-select form-control" style="display: inline;" [(ngModel)]="ver"
                        (ngModelChange)="selectVersion($event)">
                        <option *ngFor="let s of version" [id]="s" [value]="s">{{ s }}
                        </option>
                    </select>
                    <select *ngIf="!isEdit" class="custom-select form-control" style="display: inline;" disabled>
                        <option selected>1
                        </option>
                    </select>
                </div>
            </div>
        </div>
        <div class="col-12 col-md-6">
            <form [formGroup]="quotationForm">
                <div class="form-group row">
                    <label for="courseType" class="text-right col-4 col-sm-3 col-md-3 col-form-label">
                        บัญชี<lifedi-require></lifedi-require>
                    </label>
                    <div class="col-8 col-sm-9 col-md-9">
                        <select *ngIf="!isEdit" class="custom-select form-control" style="display: inline;"
                            [(ngModel)]="bankSelect" [ngClass]="ver < currentVer ? 'disable-display':''"
                            (ngModelChange)="selectBank($event, quotationForm)" [ngModelOptions]="{standalone: true}"
                            [compareWith]="compareFn">
                            <option selected hidden disabled>เลือกบัญชี</option>
                            <option *ngFor="let b of bank" [ngValue]="b">{{ b.ACCOUNTING_NAME }} ({{ b.ACCOUNTING_ID }})
                            </option>
                        </select>
                        <select *ngIf="isEdit"
                            [ngClass]="quotationDetail.STATUS === 'Done' ? 'disable-display' : quotationDetail.STATUS === 'Partial' ? 'disable-display' : quotationDetail.STATUS === 'Cancel' ? 'disable-display' : ''"
                            class="custom-select form-control" style="display: inline;" [(ngModel)]="bankSelect"
                            (ngModelChange)="selectBank($event, quotationForm)" [ngModelOptions]="{standalone: true}"
                            (ngModelChange)="onCreateGroupFormValueChange()" [compareWith]="compareFn">
                            <option *ngFor="let b of bank" [ngValue]="b">{{ b.ACCOUNTING_NAME }} ({{ b.ACCOUNTING_ID }})
                            </option>
                        </select>
                    </div>
                </div>
            </form>
        </div>
    </div>


    <div class="row d-flex justify-content-center">
        <div class="col-lg-12 col-md-12 col-sm-12">
            <mat-card class="p-3" style="width: 100%;">
                <div *ngIf="!isEdit" class="row justify-content-end px-3">
                    <button *ngIf="quotationForm.valid" (click)="print(quotationForm.value)" mat-button
                        class="print-btn mx-3">
                        <img src="assets/printer.png" alt="print">
                    </button>
                    <button *ngIf="!quotationForm.valid" mat-button class="print-btn-disable mx-3" disabled>
                        <img src="assets/printer.png" alt="print">
                    </button>
                </div>
                <div *ngIf="isEdit"
                    [ngClass]="ver < currentVer ? 'disable-display': quotationDetail.STATUS === 'Cancel' ? 'disable-display' : ''"
                    class="row justify-content-end px-3">
                    <!-- <div *ngIf="quotationDetail.STATUS === 'Wait'">
                        <button *ngIf="quotationForm.valid" (click)="print(quotationForm.value)" mat-button
                            class="print-btn mx-3">
                            <img src="assets/printer.png" alt="print">
                        </button>
                        <button *ngIf="!quotationForm.valid" mat-button class="print-btn-disable mx-3" disabled>
                            <img src="assets/printer.png" alt="print">
                        </button>
                    </div> -->
                    <!-- <div *ngIf="quotationDetail.STATUS !== 'Wait'"> -->
                    <button *ngIf="quotationForm.valid" (click)="print(quotationForm.value)" mat-button
                        class="print-btn mx-3">
                        <img src="assets/printer.png" alt="print">
                    </button>
                    <button *ngIf="!quotationForm.valid" mat-button class="print-btn-disable mx-3" disabled>
                        <img src="assets/printer.png" alt="print">
                    </button>
                    <!-- </div> -->
                </div>

                <div [ngClass]="getClass()">
                    <form [formGroup]="quotationForm">
                        <div class="row justify-content-center px-3">
                            <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                                <div class="form-group">
                                    <label for="courseType" class="form-label">
                                        ชื่อลูกค้า<lifedi-require></lifedi-require>
                                    </label>
                                    <input type="text" class="form-control" formControlName="name"
                                        (keyup)="onCreateGroupFormValueChange()">
                                </div>
                                <div class="form-group">
                                    <label for="detail" class="form-label">
                                        ข้อมูลลูกค้า<lifedi-require></lifedi-require>
                                    </label>
                                    <textarea class="form-control" id="detail" formControlName="detail" rows="5"
                                        (keyup)="onCreateGroupFormValueChange()"></textarea>
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                                <div class="form-group">
                                    <label for="title" class="form-label">
                                        หัวข้อ<lifedi-require></lifedi-require>
                                    </label>
                                    <input id="title" type="text" class="form-control" formControlName="title"
                                        (keyup)="onCreateGroupFormValueChange()">
                                </div>
                                <div class="form-group">
                                    <label for="taxId" class="form-label">
                                        เลขประจำตัวผู้เสียภาษี<lifedi-require></lifedi-require>
                                    </label>
                                    <input id="taxId" type="text" class="form-control" MaxLength="13" autocomplete="off"
                                        formControlName="taxId" (keyup)="onCreateGroupFormValueChange()">
                                </div>
                                <div class="form-group">
                                    <label for="date" class="form-label">
                                        วันที่ - วันที่ครบกำหนด<lifedi-require></lifedi-require>
                                    </label>
                                    <!-- <input id="date" class="form-control" date-format="dd-MM-yyyy HH:mm:ss"
                                    [selectMode]="'range'" formControlName="date" [owlDateTimeTrigger]="dtPicker"
                                    [owlDateTime]="dtPicker" [rangeSeparator]="'-'" dateFormat="dd-MM-yyyy"
                                    autocomplete="off"> -->
                                    <input id="date" class="form-control" [(ngModel)]="date"
                                        (ngModelChange)="selectDate($event, quotationForm)"
                                        (ngModelChange)="onCreateGroupFormValueChange()"
                                        [ngModelOptions]="{standalone: true}" date-format="dd-MM-yyyy HH:mm:ss"
                                        [selectMode]="'range'" [owlDateTimeTrigger]="dtPicker" [owlDateTime]="dtPicker"
                                        [rangeSeparator]="'-'" dateFormat="dd-MM-yyyy" autocomplete="off">
                                    <owl-date-time [pickerType]="'calendar'" #dtPicker></owl-date-time>
                                </div>
                            </div>
                        </div>

                        <div class="row d-flex justify-content-center my-4">
                            <div *ngFor="let col of column; let i = index" [class]="col.class">
                                <p class="text-center">
                                    <b>{{col.header}}</b>
                                    <span *ngIf="i !== 0 && i !== column.length - 1">
                                        <lifedi-require></lifedi-require>
                                    </span>
                                </p>
                            </div>
                        </div>
                        <div *ngFor="let w of quotationForm.get('lists')['controls']; let i = index"
                            formArrayName="lists" class="my-3">
                            <div class="row d-flex justify-content-center" [formGroupName]="i">
                                <div class="col-1">
                                    <p class="text-center">{{ i + 1 }}</p>
                                </div>
                                <div class="col-4 pl-0">
                                    <textarea class="form-control" formControlName="list" rows="3"
                                        (keyup)="onCreateGroupFormValueChange()"></textarea>
                                </div>
                                <div class="col-1 p-0">
                                    <nz-input-number [nzSize]="'large'" [nzMin]="1" formControlName="number"
                                        (ngModelChange)="getTotal(quotationFormArray, i)"
                                        (ngModelChange)="getSummary(quotationFormArray)"
                                        (ngModelChange)="detectNumber($event, quotationFormArray.at(i).controls['number'])"
                                        (ngModelChange)="onCreateGroupFormValueChange()" [nzFormatter]="formatterPrice">
                                    </nz-input-number>
                                </div>
                                <div class="col-2">
                                    <nz-input-number [nzSize]="'large'" [nzMin]="0" formControlName="unitPrice"
                                        (ngModelChange)="getTotal(quotationFormArray, i)"
                                        (ngModelChange)="getSummary(quotationFormArray)"
                                        (ngModelChange)="detectNumber($event, quotationFormArray.at(i).controls['unitPrice'])"
                                        (ngModelChange)="onCreateGroupFormValueChange()" [nzFormatter]="formatterPrice">
                                    </nz-input-number>
                                </div>
                                <div class="col-1 p-0">
                                    <nz-input-number [nzSize]="'large'" [nzMin]="0" formControlName="discount"
                                        (ngModelChange)="getTotal(quotationFormArray, i)"
                                        (ngModelChange)="getSummary(quotationFormArray)"
                                        (ngModelChange)="detectNumber($event, quotationFormArray.at(i).controls['discount'])"
                                        (ngModelChange)="onCreateGroupFormValueChange()" [nzFormatter]="formatterPrice">
                                    </nz-input-number>
                                </div>
                                <div class="col-2">
                                    <p class="text-center">
                                        <b>{{ quotationFormArray.value[i].total | number : '1.2-2' }} บาท</b>
                                    </p>
                                </div>
                                <div class="col-1">
                                    <img *ngIf="quotationFormArray.value.length > 1" src="assets/close.png" class="img"
                                        style="width: 30px; height: 30px; cursor: pointer;"
                                        (click)="removeGroup(i, quotationForm)">
                                </div>
                            </div>
                        </div>
                    </form>

                    <div class="row justify-content-center">
                        <img src="assets/add.png" class="img my-4" style="width: 30px; height: 30px; cursor: pointer;"
                            (click)="addGroup(false)">
                    </div>

                    <div class="container px-4 py-4">
                        <div class="row d-flex justify-content-center">
                            <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                                <form [formGroup]="quotationForm">
                                    <label for="note" class="form-label">หมายเหตุ</label>
                                    <textarea class="form-control" id="note" formControlName="note" rows="5"
                                        (keyup)="onCreateGroupFormValueChange()"></textarea>
                                </form>
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                                <div class="row">
                                    <div class="col-6">
                                        <p class="text-left">รวมเงิน</p>
                                        <p class="text-left text-danger">ส่วนลด</p>
                                        <p class="text-left">ราคาไม่รวมภาษีมูลค่าเพิ่ม</p>
                                        <mat-checkbox id="vat" [ngClass]="vat ? '' : 'text-secondary'" [(ngModel)]="vat"
                                            (change)="calNetPrice()" (change)="onCreateGroupFormValueChange()"
                                            class="form-control-plaintext p-0">
                                            ภาษีมูลค่าเพิ่ม (7%)
                                        </mat-checkbox>
                                        <h5 class="text-left text-primary mt-4">รวมราคาสุทธิ</h5>
                                    </div>
                                    <div class="col-6">
                                        <p class="text-right">
                                            {{ total | number : '1.2-2' }} บาท
                                        </p>
                                        <p class="text-right text-danger">
                                            {{ discount | number : '1.2-2' }} บาท
                                        </p>
                                        <p class="text-right">
                                            {{ priceWithoutVat | number : '1.2-2' }} บาท
                                        </p>
                                        <p class="text-right" [ngClass]="vat ? '' : 'text-secondary'">
                                            {{ vatPrice | number : '1.2-2' }} บาท
                                        </p>
                                        <h5 class="text-right text-primary" style="margin-top: 36px;">
                                            {{ totalNetPrice | number : '1.2-2' }} บาท
                                        </h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="isEdit" class="row justify-content-center">
                    <p *ngIf="quotationDetail.STATUS !== 'Wait'" class="text-center text-danger mt-2">
                        *กรณีสร้างใบแจ้งหนี้แล้วจะแก้ไขใบเสนอราคาไม่ได้
                        หากต้องการแก้ไขกรุณากดยกเลิกใบแจ้งหนี้ก่อน
                    </p>
                </div>
            </mat-card>
        </div>
    </div>


    <div *ngIf="isEdit" class="row justify-content-center pb-5 pt-4">
        <div *ngIf="quotationDetail.STATUS === 'Wait'">
            <div *ngIf="ver == currentVer">
                <div *ngIf="!hasChange">
                    <lifedi-btn lable="ปิด" (click)="close()"
                        customStyle="background-color: #060E9F; color: #FFF; margin: 0px; padding: 0 30px;">
                    </lifedi-btn>
                </div>
                <div *ngIf="hasChange">
                    <lifedi-btn *ngIf="quotationForm.valid" lable="บันทึก"
                        (click)="updateQuotation(quotationForm.value)"
                        customStyle="background-color: #060E9F; color: #FFF; margin: 0px; padding: 0 30px;">
                    </lifedi-btn>
                    <lifedi-btn *ngIf="!quotationForm.valid" lable="บันทึก" disabled="true"
                        customStyle="margin: 0px; padding: 0 30px;">
                    </lifedi-btn>
                </div>
            </div>
        </div>
        <div
            *ngIf="ver < currentVer || quotationDetail.STATUS === 'Done' || quotationDetail.STATUS === 'Partial' || quotationDetail.STATUS === 'Cancel'">
            <lifedi-btn lable="ปิด" (click)="close()"
                customStyle="background-color: #060E9F; color: #FFF; margin: 0px; padding: 0 30px;">
            </lifedi-btn>
        </div>
    </div>
    <div *ngIf="!isEdit" class="row justify-content-center pb-5 pt-4">
        <lifedi-btn *ngIf="quotationForm.valid" lable="บันทึก" (click)="save(quotationForm.value)"
            customStyle="background-color: #060E9F; color: #FFF; margin: 0px; padding: 0 30px;">
        </lifedi-btn>
        <lifedi-btn *ngIf="!quotationForm.valid" lable="บันทึก" disabled="true"
            customStyle="margin: 0px; padding: 0 30px;">
        </lifedi-btn>
    </div>
</div>

<div *ngIf="canPrint">
    <div *ngIf="printDetail.printData.detail.ACCOUNTING_NAME === 'คณะจิตวิทยา จุฬาลงกรณ์มหาวิทยาลัย'">
        <lifedi-print-quotation-agency [printDetail]="printDetail"></lifedi-print-quotation-agency>
    </div>
    <div *ngIf="printDetail.printData.detail.ACCOUNTING_NAME === 'บริษัทผลิตภัณฑ์นวัตกรรมจามจุรี จำกัด'">
        <lifedi-print-quotation-organization [printDetail]="printDetail"></lifedi-print-quotation-organization>
    </div>
</div>

<div *ngIf="isLoading">
    <div
        style="position: fixed; z-index: 900; width: 100vw; height: 100vh; opacity: 80; top: 0; left: 0; background: #e8e8e880;">
    </div>
    <mat-spinner class="spinner-center" style="z-index: 1000;"></mat-spinner>
</div>